<template>
    <el-container>
        <el-main class="wrapper__body" style="margin-left: 0px;">
            <Navbar :is_production="is_production" title="Site" style="width: 100%"></Navbar>
            <el-container class="main-section">
                <div class="col-md-12">
                    <el-tabs v-model="activeTab" @tab-click="handleTab">
                        <el-tab-pane label="Event Gallery Menu" name="event_gallery_menu">
                            <event-gallery-menu ref="eventGalleryMenu" :is_production="is_production"></event-gallery-menu>
                        </el-tab-pane>
                        <el-tab-pane label="News Menu" name="news_menu">
                            <news-menu ref="newsMenu" :is_production="is_production"></news-menu>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <!--DIALOGS-->
                
                <!--DIALOGS-->
            </el-container>
        </el-main>
    </el-container>
</template>

<script>
    import Navbar from "../../../components/admin/Navbar";
    import EventGalleryMenu from "../EventGallery/EventGalleryMenu.vue";
    import NewsMenu from "../News/NewsMenu.vue";
    export default {
        props:{
            is_production: Boolean,
        },
        components: { Navbar },
        data () {
            return {
                // img: this.$root.folder_name + '/public/assets/img/directory_home.png',
                // contents: [],
                activeTab: 'event_gallery_menu',
                env_wp: this.$root.env_wp.env_wp,
                content: {
                    fileList: [],
                    featured_content_title: '',
                    featured_content: '',
                },
                tableLoading: false,
                tableLoadingCategory: false,
                dialogVisible: false,
                dialogVisible2: false,
                resources: {
                    categories: [],
                    event_galleries: [],
                },
                category:{
                    name: ''
                },
                event_gallery: {
                    title: '',
                    category_id: '',
                    content: '',
                    event_date: '',
                    fileList: [],
                },
                
                custom_modal_title: '',
                customModalVisible: false,
            }
        },
        mounted() {
        },
        methods: {
            async handleTab(tab, event){
                if(tab.name == 'event_gallery_menu'){
                    await this.$refs.eventGalleryMenu.getAllContents();
                }

                if(tab.name == 'news_menu'){
                    await this.$refs.newsMenu.getAllContents();
                }
            },
            getAllContents(){

            },
            toggleWhatsAndEventModal(content, type){
                //CONTENT: 1-whats going on, 2-events
                //TYPE: 'create', 'edit'
                if(content == 1){
                    if(type == 'create'){
                        this.custom_modal_title = "Add What's Going On Content";
                        //insert axios post here
                    }

                    if(type == 'edit'){
                        this.custom_modal_title = "Edit What's Going On Content";
                        //insert axios post here
                    }
                }

                if(content == 2){
                    if(type == 'create'){
                        this.custom_modal_title = "Add Events Content";
                        //insert axios post here
                    }

                    if(type == 'edit'){
                        this.custom_modal_title = "Edit Events Content";
                        //insert axios post here
                    }
                }
            },
            handleRemove(file, fileList) {
                const index = this.event_gallery.fileList.indexOf(file);
                this.event_gallery.fileList.splice(index, 1);
            },
            handleChange(file, fileList) {
                // if(this.content.type == 2){
                //     this.content.fileList.splice(0, 1);
                //     this.content.fileList = fileList;
                // }else{
                //     this.content.fileList = fileList;
                // }
                this.event_gallery.fileList.splice(0, 1);
                this.event_gallery.fileList = fileList;
            },
            submitFeaturedImages(){
                this.$refs['uploadForm'].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        if(this.content.fileList.length > 0){
                            for(var i=0; i < this.content.fileList.length; i++) {
                                formData.append('files[]', this.content.fileList[i].raw);
                            }
                        }
                        axios.post(this.env_wp.FOLDER_NAME + '/news/submit_featured_images', formData)
                            .then(res => {
                                // this.getHeadersList();
                                this.$swal(res.data.title, res.data.text, res.data.type);
                                this.content.fileList = [];
                                this.dialogVisible = false;
                            })
                            .catch(err => {
                                //
                            });
                    }
                });
            },
            submitFeaturedContent(){
                if(this.content.featured_content === ''){
                    this.$swal('Oops', 'Content cannot be empty.', 'error');
                }else{
                    var params = {
                        featured_content: this.resources.featured_content
                    }
                    axios.post(this.env_wp.FOLDER_NAME + '/news/submit_featured_content', params)
                    .then(res => {
                        this.$swal(res.data.title, res.data.text, res.data.type);
                        //INSERT GET FEATURED CONTENT METHOD HERE
                    })
                    .catch(err => {

                    })
                }
            },
            submitCategory(){
                var endpoint = '';
                if(this.category.name === ''){
                    this.$swal('Oops', 'Category name cannot be empty.', 'error');
                }else{
                    endpoint = (this.category.id === undefined) ? 'create_category' : 'update_category';

                    axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/'+ endpoint, this.category)
                    .then(res => {
                        this.$swal(res.data.title, res.data.text, res.data.type);
                        this.dialogVisible = false;
                        this.category = {
                            name: ''
                        };
                        this.getCategories();
                    })
                    .catch(err => {

                    })
                }
            },
            getCategories(){
                this.tableLoadingCategory = true;
                axios.get(this.env_wp.FOLDER_NAME + '/event_gallery/get_categories')
                    .then(res => {
                        this.resources.categories = res.data;
                        this.tableLoadingCategory = false;
                        this.event_gallery.category_id = this.resources.categories[0].id;
                    })
                    .catch(err => {
                        this.resources.categories = [];
                        this.tableLoadingCategory = false;
                        this.event_gallery.category_id = '';
                    });
            },
            editCategory(category){
                this.category = category;
                this.dialogVisible = true;
            },
            closeCategory(){
                this.dialogVisible = false;
                this.category = {
                    name: ''
                };
            },
            deleteCategory(category){
                this.$swal({
                    title: 'Confirm?',
                    text: "Are you sure you want to delete this category?",
                    icon: 'warning',
                    buttons: true,
                    dangerMode: true,
                    showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/delete_category', {id: category.id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getCategories();
                        })
                        .catch(err => {
                            //
                        });
                    }
                });
            },
            submitEventGalleryContent(){
                if(this.event_gallery.title === ''){
                    this.$swal('Oops', 'Title cannot be empty.', 'error');
                    return;
                }
                // if(this.event_gallery.content === ''){
                //     this.$swal('Oops', 'Content cannot be empty.', 'error');
                //     return;
                // }
                if(this.event_gallery.event_date === ''){
                    this.$swal('Oops', 'Event date cannot be empty.', 'error');
                    return;
                }
                var endpoint = (this.event_gallery.id === undefined) ? 'submit_event_gallery' : 'update_event_gallery';
                this.$refs['uploadForm'].validate((valid) => {
                    if (valid) {
                        let formData = new FormData();
                        if(this.event_gallery.id !== undefined) formData.append('id', this.event_gallery.id);
                        formData.append('title', this.event_gallery.title);
                        formData.append('content', this.event_gallery.content);
                        formData.append('category_id', this.event_gallery.category_id);
                        const localDate = new Date(this.event_gallery.event_date);
                        const adjustedDate = new Date(localDate.getTime() - localDate.getTimezoneOffset() * 60000).toISOString().split('T')[0];
                        formData.append('event_date', adjustedDate);
                        if(this.event_gallery.fileList.length > 0){
                            for(var i=0; i < this.event_gallery.fileList.length; i++) {
                                formData.append('files[]', this.event_gallery.fileList[i].raw);
                            }
                        }
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/'+ endpoint, formData)
                            .then(res => {
                                this.$swal(res.data.title, res.data.text, res.data.type);
                                this.event_gallery = {
                                    title: '',
                                    content: '',
                                    category_id: this.resources.categories[0].id,
                                    event_date: '',
                                    fileList: [],
                                };
                                this.dialogVisible2 = false;
                                this.getEventGallery();
                            })
                            .catch(err => {
                                //
                            });
                    }
                });
            },
            closeContentModal(){
                this.dialogVisible2 = false;
                this.event_gallery = {
                    title: '',
                    content: '',
                    category_id: this.resources.categories[0].id,
                    event_date: '',
                    fileList: [],
                };
                
            },
            getEventGallery(){
                this.tableLoading = true;
                axios.get(this.env_wp.FOLDER_NAME + '/event_gallery/get_event_gallery')
                .then(res => {
                    this.resources.event_galleries = res.data;
                    this.tableLoading = false;
                })
                .catch(err => {
                    this.resources.event_galleries = [];
                    this.tableLoading = false;
                });
            },
            editEventGalleryContent(content){
                this.event_gallery = content;
                this.event_gallery.fileList = [];
                this.dialogVisible2 = true;
            },
            deleteContentImage(id){
                this.$swal({
                icon: 'warning',
                title: 'Confirm?',
                html: 'Are you sure you want to delete this image?',
                showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/delete_content_image', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getEventGallery();
                            this.closeContentModal();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            },
            deleteContent(id){
                this.$swal({
                    icon: 'warning',
                    title: 'Confirm?',
                    html: 'Are you sure you want to delete this content?',
                    showCancelButton: true
                }).then((result) => {
                    if (result.isConfirmed) {
                        axios.post(this.env_wp.FOLDER_NAME + '/event_gallery/delete_content', {id: id})
                        .then(res => {
                            this.$swal(res.data.title, res.data.text, res.data.type);
                            this.getEventGallery();
                        })
                        .catch(err => {
                            //
                        });
                    }
                })
            }
        }
    }
</script>
